import React from 'react';

import RoleLayout from './RoleLayout';
import { createAdminHeaderMenuConfig } from '../../Components/HeaderMenu/menuConfig';

export default function AdminLayout(props) {
    return (
        <RoleLayout
            {...props}
            scope="admin"
            fallbackPath="/"
            menuConfig={() => createAdminHeaderMenuConfig()}
        />
    );
}



// WEBPACK FOOTER //
// ./src/hoc/Layout/AdminLayout.js